"use strict";

require("core-js/modules/es6.function.name");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireDefault(require("react"));

var _semanticUiReact = require("semantic-ui-react");

var _awsSdk = _interopRequireDefault(require("aws-sdk"));

var _reactGa = _interopRequireDefault(require("react-ga"));

var _Completion = _interopRequireDefault(require("./Completion"));

var _EmailService = _interopRequireDefault(require("../EmailService"));

var RequestEditModal =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2["default"])(RequestEditModal, _React$Component);

  function RequestEditModal() {
    var _this;

    (0, _classCallCheck2["default"])(this, RequestEditModal);
    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(RequestEditModal).call(this));
    _this.state = {
      currentRequestMessage: '',
      requestInProgress: true
    };
    _this.handleRequestChange = _this.handleRequestChange.bind((0, _assertThisInitialized2["default"])(_this));
    _this.submitRequest = _this.submitRequest.bind((0, _assertThisInitialized2["default"])(_this));
    _this.clickToPublish = _this.clickToPublish.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }

  (0, _createClass2["default"])(RequestEditModal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      _awsSdk["default"].config.update({
        region: 'us-east-1',
        credentials: new _awsSdk["default"].Credentials(process.env.AWS_ACCESS_KEY_ID, process.env.AWS_SECRET_ACCESS_KEY)
      });
    }
  }, {
    key: "handleRequestChange",
    value: function handleRequestChange(e, _ref) {
      var value = _ref.value;
      this.setState({
        currentRequestMessage: value
      });
    }
  }, {
    key: "submitRequest",
    value: function submitRequest() {
      var _this2 = this;

      var currentRequestMessage = this.state.currentRequestMessage;
      var business = this.props.business;
      var name = business.name;
      var subject = "Edit Requested - ".concat(name);
      var content = "".concat(name, " has requested an edit: ").concat(currentRequestMessage);
      (0, _EmailService["default"])({
        businessName: name,
        subject: subject,
        content: content
      }).then(function () {
        _this2.setState({
          requestInProgress: false
        });
      });
    }
  }, {
    key: "clickToPublish",
    value: function clickToPublish() {
      var _this$props = this.props,
          handlePublishOpen = _this$props.handlePublishOpen,
          handleRequestEditClose = _this$props.handleRequestEditClose;
      handlePublishOpen();
      handleRequestEditClose();
    }
  }, {
    key: "logEvent",
    value: function logEvent(step) {
      var business = this.props.business;

      _reactGa["default"].event({
        category: 'Checkout',
        action: "Step ".concat(step),
        label: business.name
      });
    }
  }, {
    key: "renderRequestEdit",
    value: function renderRequestEdit() {
      var _this3 = this;

      var handleRequestEditClose = this.props.handleRequestEditClose;
      this.logEvent('Request Edit');
      return _react["default"].createElement(_react["default"].Fragment, null, _react["default"].createElement(_semanticUiReact.Modal.Header, {
        className: "modal-header"
      }, "Request an edit"), _react["default"].createElement("div", {
        className: "modal-content modal-body"
      }, _react["default"].createElement("span", {
        className: "body-text blue-color"
      }, "Please note that once you publish your site, you can easily edit content, color, and font through your website\u2019s dashboard.\xA0", _react["default"].createElement(_semanticUiReact.Button, {
        id: "publish-now-from-request-button",
        className: "publish-now-from-request-button body-text blue-color",
        onClick: this.clickToPublish
      }, "Click here"), "\xA0to publish now. If you have a more specific request, describe it below and we\u2019ll get back to you within 48 hours."), _react["default"].createElement("h3", {
        className: "header-text blue-color extra-margin"
      }, "Describe your request here"), _react["default"].createElement(_semanticUiReact.TextArea, {
        id: "request-text-area",
        type: "text",
        placeholder: "Type something",
        className: "request-input",
        onChange: this.handleRequestChange
      }), _react["default"].createElement("div", {
        className: "centered-content extra-margin"
      }, _react["default"].createElement(_semanticUiReact.Button, {
        id: "back-button-request-edit",
        className: "back-edit-request-button blue-color body-text",
        onClick: handleRequestEditClose
      }, "Back"), _react["default"].createElement(_semanticUiReact.Button, {
        id: "submit-edit-request-button",
        className: "submit-edit-request-button body-text green-background-color",
        onClick: function onClick() {
          return _this3.submitRequest();
        }
      }, "Submit"))));
    }
  }, {
    key: "renderCompletion",
    value: function renderCompletion() {
      this.logEvent('Request Edit Completion');
      return _react["default"].createElement(_Completion["default"], {
        title: "Submission Complete",
        description: "We will text you a link to your edited site within 48 hours."
      });
    }
  }, {
    key: "render",
    value: function render() {
      var requestInProgress = this.state.requestInProgress;
      var _this$props2 = this.props,
          showRequestEditModal = _this$props2.showRequestEditModal,
          handleRequestOpen = _this$props2.handleRequestOpen,
          handleRequestClose = _this$props2.handleRequestClose;
      var modalBody = requestInProgress ? this.renderRequestEdit() : this.renderCompletion();
      return _react["default"].createElement(_semanticUiReact.Modal, {
        id: "request-edit-modal",
        trigger: _react["default"].createElement(_semanticUiReact.Button, {
          id: "request-edit-button",
          className: "payment-request-button"
        }, "Request an edit"),
        className: "modal-container",
        dimmer: "inverted",
        open: showRequestEditModal,
        onOpen: handleRequestOpen,
        onClose: handleRequestClose,
        closeIcon: _react["default"].createElement(_semanticUiReact.Button, {
          id: "inside-close-icon",
          className: "inside-close-icon",
          icon: true
        }, _react["default"].createElement(_semanticUiReact.Icon, {
          name: "close"
        }))
      }, modalBody);
    }
  }]);
  return RequestEditModal;
}(_react["default"].Component);

exports["default"] = RequestEditModal;